module.exports = __webpack_public_path__ + "assets/img/3.b5a9425b.png";